import React from 'react';

// CustomTooltip.jsx
const CustomTooltip = ({ active, payload, label }) => {
    if (!active || !payload || !payload.length) {
      return null;
    }
  
    // Extract the specific values we need
    let minValue = "-";
    let priceChangeValue = "-";
    let maxValue = "-";
    let overhangValue = "-";
  
    // Find each value in the payload
    payload.forEach(entry => {
      if (entry.dataKey === "price_change_10th" && entry.stroke !== "transparent") {
        minValue = entry.value?.toFixed(2) || "-";
      } 
      else if (entry.dataKey === "price_change") {
        priceChangeValue = entry.value?.toFixed(1) || "-";
      } 
      else if (entry.dataKey === "price_change_90th" && entry.stroke !== "transparent") {
        maxValue = entry.value?.toFixed(2) || "-";
      } 
      else if (entry.dataKey === "overhang") {
        overhangValue = Math.round(entry.value) || "-";
      }
    });
  
    return (
      <div style={{ backgroundColor: "rgba(255, 255, 255, 0.94)" }} className=" p-2 rounded shadow-lg border border-gray-300">
          <div className="flex justify-between w-max items-center" style={{width: "174px"}}>
            <div className="w-max text-xs">Date: </div>
            <div className="text-left text-xs"><strong>{label}</strong></div>
          </div>
          <div className="flex justify-between w-max items-center" style={{width: "174px"}}>
            <div className="w-max text-xs">Price Change: </div>
            <div className="text-left text-xs"><strong>{priceChangeValue}</strong>%</div>
          </div>
          
          <div className="flex justify-between w-max items-center" style={{width: "174px"}}>
            <div className="w-max text-xs">Inventory Overhang:  </div>
            <div className="text-left text-xs"><strong>{overhangValue}</strong> days</div>
          </div>
      </div>
      
    );
  };
  
  // To use this tooltip, replace the Tooltip component in your LineChart:
  // <Tooltip content={<CustomTooltip />} />

export default CustomTooltip;